import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '@core/layout/component/main-layout/main-layout.component';
import { PreAuthLayoutComponent } from '@core/layout/component/pre-auth-layout/pre-auth-layout.component';
import { authGuard } from '@shared/guard/auth.guard';
import { hasReferralGuard } from '@shared/guard/has-referral.guard';
import { hasToFillPersonalDataGuard } from '@shared/guard/has-to-fill-personal-data.guard';
import { MidAuthLayoutComponent } from '@core/layout/component/mid-auth-layout/mid-auth-layout.component';
import { hasToBookTriage } from '@shared/guard/has-to-book-triage.guard';
import { hasToCompleteTutorial } from '@shared/guard/has-to-complete-tutorial';
import { hasAssignedPsychologistGuard } from '@shared/guard/has-assigned-psychologist.guard';

const routes: Routes = [
  {
    path: '', component: MainLayoutComponent,
    canActivate: [ authGuard, hasToFillPersonalDataGuard, hasToBookTriage, hasToCompleteTutorial, hasReferralGuard ],
    children: [
      {
        path: '',
        loadChildren: () => import('app/view/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'consultations',
        loadChildren: () => import('app/view/consultations/consultations.module').then(m => m.ConsultationsModule)
      },
      {
        path: 'journal',
        loadChildren: () => import('app/view/journal/journal.module').then(m => m.JournalModule)
      },
      {
        path: 'help',
        loadChildren: () => import('app/view/help/help.module').then(m => m.HelpModule)
      },
      {
        path: 'account',
        loadChildren: () => import('app/view/account/account.module').then(m => m.AccountModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('app/view/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'conversations',
        loadChildren: () => import('app/view/conversations/conversations.module').then(m => m.ConversationsModule),
        canActivate: [ hasAssignedPsychologistGuard ]
      },
      {
        path: 'health-monitor',
        loadChildren: () => import('app/view/health-monitor/health-monitor.module').then(m => m.HealthMonitorModule)
      },
    ]
  },
  {
    path: 'auth',
    component: PreAuthLayoutComponent,
    loadChildren: () => import('app/view/auth/auth-page.module').then(m => m.AuthPageModule)
  },
  {
    path: 'fill-content',
    component: MidAuthLayoutComponent,
    canActivate: [ authGuard, hasToFillPersonalDataGuard ],
    loadChildren: () => import('app/view/fill-content/fill-content.module').then(m => m.FillContentModule)
  },
  {
    path: 'error',
    loadChildren: () => import('app/view/error/error-page.module').then(m => m.ErrorPageModule)
  },
  { path: '**', redirectTo: 'error/not-found' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {
}
